import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { sugerirClassificacao, chamadosSemelhantes } from '../../../api/iaAssist';
import './AssistenteIA.css';

// Assistente de IA no chamado (Fase 7): classificação sugerida e duplicados.
function AssistenteIA({ satNum }) {
  const history = useHistory();
  const [classif, setClassif] = useState(null);
  const [semelhantes, setSemelhantes] = useState(null);
  const [loadingC, setLoadingC] = useState(false);
  const [loadingS, setLoadingS] = useState(false);

  if (!satNum || satNum <= 0) return null;

  const rodarClassificacao = async () => {
    setLoadingC(true);
    setClassif(null);
    const r = await sugerirClassificacao(satNum);
    setClassif(r);
    setLoadingC(false);
  };

  const rodarSemelhantes = async () => {
    setLoadingS(true);
    setSemelhantes(null);
    const r = await chamadosSemelhantes(satNum);
    setSemelhantes(r);
    setLoadingS(false);
  };

  const s = classif && classif.sugestao;

  return (
    <div className="assistente-ia">
      <div className="assistente-ia-titulo"><i className="fas fa-wand-magic-sparkles me-2" />Assistente de IA</div>

      <button type="button" className="assistente-ia-btn" onClick={rodarClassificacao} disabled={loadingC}>
        {loadingC ? <><i className="fas fa-spinner fa-spin me-1" />Analisando…</> : <><i className="fas fa-tags me-1" />Sugerir classificação</>}
      </button>

      {classif && classif.erro && <div className="assistente-ia-erro">{classif.erro}</div>}
      {classif && !classif.erro && !s && <div className="assistente-ia-vazio">{classif.mensagem || 'Sem sugestão.'}</div>}
      {s && (
        <div className="assistente-ia-resultado">
          {s.tipo_nome && <div><span className="assistente-ia-rotulo">Tipo:</span> {s.tipo_nome}</div>}
          {s.categoria_nome && <div><span className="assistente-ia-rotulo">Categoria:</span> {s.categoria_nome}</div>}
          {s.responsavel_nome && <div><span className="assistente-ia-rotulo">Responsável:</span> {s.responsavel_nome}</div>}
          {!s.tipo_nome && !s.categoria_nome && !s.responsavel_nome && <div className="assistente-ia-vazio">Sem padrão claro nos parecidos.</div>}
          {(classif.baseado_em || []).length > 0 && (
            <div className="assistente-ia-base">
              Confiança {classif.confianca}% · baseado em {classif.baseado_em.length} chamado(s) parecido(s)
            </div>
          )}
        </div>
      )}

      <button type="button" className="assistente-ia-btn" onClick={rodarSemelhantes} disabled={loadingS}>
        {loadingS ? <><i className="fas fa-spinner fa-spin me-1" />Buscando…</> : <><i className="fas fa-clone me-1" />Chamados semelhantes</>}
      </button>

      {semelhantes && semelhantes.erro && <div className="assistente-ia-erro">{semelhantes.erro}</div>}
      {semelhantes && !semelhantes.erro && (semelhantes.itens || []).length === 0 && (
        <div className="assistente-ia-vazio">Nenhum chamado aberto parecido.</div>
      )}
      {semelhantes && (semelhantes.itens || []).length > 0 && (
        <ul className="assistente-ia-lista">
          {semelhantes.itens.map((it) => (
            <li key={it.satNum}>
              <button type="button" className="assistente-ia-link" onClick={() => history.push(`/historicoSati/${it.satNum}`)}>
                #{it.satNum}
              </button>
              <span className="assistente-ia-desc" title={it.descricao}>{it.descricao}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default AssistenteIA;
